import { decamelize } from 'helpers/camelize';
import {
  fetchWrapper,
  formatBody,
  handleResponse,
  hcUrl,
  buildOpts,
  objectToQueryString,
} from 'services/RequestService/helpers';

export const getUserOffer = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrl(`/user_offers/offer?${objectToQueryString(decamelize(params, true))}`),
    buildOpts({
      method: 'GET',
    })
  );
  return handleResponse(response);
};

export const claimUserOffer = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrl('/user_offers/claims'),
    buildOpts({
      method: 'POST',
      body: formatBody({ claim: params }),
    })
  );
  return handleResponse(response);
};
